import React from 'react';
import { observer } from 'mobx-react';
import truncate from 'lodash/truncate';
import { Dropdown, DropdownItem, DropdownItemIcon, DropdownSection, DropdownSectionTitle } from '../../../../../components/Dropdown';
import Avatar from '../../../../../components/Avatar';
import { iconType } from '../../../../../utils/iconUtil';
import FileTypeIcon from '../../../../../components/FileTypeIcon';
import Icon from '../../../../../components/Icon';
import IconButton from '../../../../../components/IconButton';
import styles from './VersionList.m.sass';
var VersionList = function VersionList(_ref) {
  var view = _ref.view;
  var versions = view.document.history;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.versions
  }, versions.map(function (version) {
    return /*#__PURE__*/React.createElement(VersionItem, {
      version: version,
      key: version.id,
      view: view
    });
  })));
};
var VersionItem = observer(function (_ref2) {
  var version = _ref2.version,
    view = _ref2.view;
  var isLatest = view.document.history[0] === version;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.versionItem
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.versionHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.versionAuthor
  }, /*#__PURE__*/React.createElement(Avatar, {
    url: version.author.avatar,
    fallback: version.author.avatarFallback,
    title: version.author.displayName,
    size: 30
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.versionInfo
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.versionTitle,
    title: version.message
  }, truncate(version.message, {
    length: 50
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.versionSubtitle
  }, version.dateCreated.format('LL LT'))), !isLatest && !view.busy && /*#__PURE__*/React.createElement("div", {
    className: styles.versionActions
  }, /*#__PURE__*/React.createElement(Dropdown, {
    position: "right",
    button: function button(buttonProps) {
      return /*#__PURE__*/React.createElement(IconButton, buttonProps, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "more horiz"
      }));
    }
  }, /*#__PURE__*/React.createElement(DropdownSection, null, /*#__PURE__*/React.createElement(DropdownSectionTitle, null, "Actions"), /*#__PURE__*/React.createElement(DropdownItem, {
    disabled: isLatest,
    onClick: function onClick() {
      return view.revertToVersion(version);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    small: true,
    material: true,
    name: "restore"
  })), "Revert to this version"))))), /*#__PURE__*/React.createElement(FileList, {
    version: version,
    view: view,
    purged: version.purged
  }));
});
var FileList = observer(function (_ref3) {
  var version = _ref3.version,
    view = _ref3.view,
    purged = _ref3.purged;
  var files = version.files;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.files
  }, files.map(function (file) {
    return /*#__PURE__*/React.createElement(FileItem, {
      file: file,
      version: version,
      view: view,
      key: file.id,
      purged: purged
    });
  }));
});
var FileItem = observer(function (_ref4) {
  var file = _ref4.file,
    version = _ref4.version,
    view = _ref4.view,
    purged = _ref4.purged;
  var icon = iconType(file.fileName);
  var createdTs = file.dateCreated.format('LL LT');
  return /*#__PURE__*/React.createElement("div", {
    key: file.id,
    className: styles.fileItem
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fileIcon
  }, /*#__PURE__*/React.createElement(FileTypeIcon, {
    height: "28",
    primaryColor: icon.color,
    strokeColor: "#bcbcbe",
    type: icon.type,
    label: document.fileType,
    animate: true
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.fileInfo
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.fileTitle,
    title: file.fileName
  }, truncate(file.fileName, 30)), /*#__PURE__*/React.createElement("p", {
    className: styles.fileSubtitle,
    title: createdTs
  }, createdTs)), !purged && /*#__PURE__*/React.createElement(FileActionOrIcon, {
    file: file,
    version: version,
    view: view
  }));
});
var FileActionOrIcon = observer(function (_ref5) {
  var file = _ref5.file,
    version = _ref5.version,
    view = _ref5.view;
  switch (file.state) {
    case 'Pending':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This file is waiting for a virus scan to complete"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "hourglass empty"
      }));
    case 'Scanning':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This file is currently undergoing a virus scan"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "sync"
      }));
    case 'VerifyingClientData':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This document is currently undergoing a client data verification"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "sync"
      }));
    case 'ManualVerificationRequired':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This document requires manual verification"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "warning"
      }));
    case 'Downloadable':
      return /*#__PURE__*/React.createElement("div", {
        className: styles.fileActions
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick(e) {
          return e.preventDefault() || view.download(version, file);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "file download"
      })));
    case 'Purged':
      return /*#__PURE__*/React.createElement("span", {
        className: styles.status,
        title: "This file is infected with a virus and is not available for download"
      }, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "bug report"
      }));
    default:
  }
});
export default observer(VersionList);
//# sourceMappingURL=index.js.map
